import {DomainObject} from 'shared/store';
import {observable} from 'mobx';

class PTOSummary extends DomainObject {
  @observable requestsCount;
  @observable lateRequestsCount;
}

export default PTOSummary;
